import {
  LoadingController,
  NavController,
  MenuController,
  ToastController,
} from '@ionic/angular';
import { Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { GlobalProvider } from 'src/services/global';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

// import { ChatService } from 'src/services/chat.service';

@Injectable({
  providedIn: 'root',
})
export class BaseHelper {
  gLoading: any;
  DataGot: boolean = true;
  constructor(
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected navCtrl: NavController,
    protected menu: MenuController,
    protected g: GlobalProvider
  ) {
    this.initLoadLoading();
  }
  menuOpen() {
    console.log(`menuopen`);
    this.menu.enable(true);
  }
  menuClose() {
    this.menu.enable(false);
  }
  async toast(message: any, duration = 1000, color = `success`) {
    const toast = await this.toastController.create({
      message,
      duration,
      color,
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }
  async initLoadLoading() {
    this.gLoading = await this.loadingCtrl.create({
      message: 'Please Wait...',
    });
  }
  async loadLoading(toggle = true) {
    console.log(toggle, 'line 81 baseHelper.ts');
    if (toggle) {
      if (!this.gLoading) {
        await this.initLoadLoading();
      }
      this.gLoading.present();
    } else {
      if (this.gLoading) {
        await this.gLoading.dismiss();
      }

      this.initLoadLoading();
    }
    return;
  }


  setStorage(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getStorage(key: any) {
    const dat = localStorage.getItem(key);
    if (dat) {
      return JSON.parse(dat)
    } else {
      return null
    }
  }

  setJws(token:any, profile:any, mediaUrl:any, config:any) {
    console.log(`setJws called?`, mediaUrl);
    // console.log(`profile`, profile);
    this.setStorage('companyToken', token);
    this.g.jws = "Bearer "+token;
    this.g.profile = profile;
    // this.g.profileType = tokenObj.profileType;
    this.g.role = profile.role;
    this.g.accessRole = profile.accessRole;
    this.g.mediaUrl = mediaUrl;
    this.g.config = config;
  }
  async clearJws() {
    console.log(`clearJws called?`);
    this.g.jws = null;
    this.g.profile = null;
    this.g.profileType = null;
    this.g.accessRole = null;
    this.g.role = null;
  }
  async getJws() {
    return await this.getStorage('companyToken');
  }
  navigateRoot(path: any, queryParams = null) {
    if (queryParams) {
      const navigationExtras: NavigationExtras = {
        queryParams,
      };
      this.navCtrl.navigateRoot(path, navigationExtras);
    } else {
      this.navCtrl.navigateRoot(path);
    }
  }
  navigate(path: any) {
    this.navCtrl.navigateForward(path);
  }

  pop() {
    this.navCtrl.pop();
  }

  async danger(message: any, duration: any = 1000) {
    console.log(duration);
    if (!duration) {
      duration = 300;
    }
    const toast = await this.toastController.create({
      message,
      duration,
      color: 'danger',
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }
  async openTab(url: any) {
    // Check if running on web platform
    if (Capacitor.getPlatform() === 'web') {
      // Open in new tab for web browsers
      window.open(url, '_blank');
    } else {
      // Use Capacitor Browser for native platforms (iOS/Android)
      await Browser.open({ url });
    }
  }

}
